import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { SubscriptionDetails} from '../modal';

export default function reducer(state: SubscriptionDetails = new SubscriptionDetails(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SUBSCRIPTION_DETAILS_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SUBSCRIPTION_DETAILS_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
